import { httpQuery } from '@luminovo/data-stack';
import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, notFound } from '@tanstack/react-router';

import { SupplierDetailsPage } from '@/areas/suppliers/Suppliers/SupplierDetailsPage';
import type { PageStaticData } from '@/shared/routing';

// An id the page's list lacks renders the not-found page: a deleted supplier's, or a path below `/suppliers` no other
// route claims. The cached list may predate a supplier just created, so the loader asks again unless it is fresh.
export const Route = createFileRoute('/_authenticated/suppliers/$supplierAndStockLocationId')({
    staticData: { access: { permissions: ['view:supplier'] }, chrome: 'home' } satisfies PageStaticData,
    validateSearch: stringSearch({ tab: 'optional' }),
    loader: async ({ context: { queryClient }, params: { supplierAndStockLocationId } }) => {
        const suppliers = httpQuery('GET /suppliers-and-stock-locations', {});
        const lists = ({ data }: { data: { id: string }[] }) =>
            data.some((supplier) => supplier.id === supplierAndStockLocationId);
        if (!lists(await queryClient.ensureQueryData(suppliers)) && !lists(await queryClient.fetchQuery(suppliers))) {
            throw notFound();
        }
    },
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const tab = Route.useSearch({ select: (search) => search.tab });
    return <SupplierDetailsPage {...pathParams} tab={tab} />;
}
